import React from 'react';

const HowToJoinSection = () => {
  return (
    <section id="join" className="section">
      <div className="container">
        <h2>How to Join</h2>
        <div className="content-card">
          <p className="join-description">
            Interested in participating in this exciting AWS GameDay event?
            Registration is managed through individual participating user groups.
          </p>
          <div className="join-steps">
            <div className="join-step">
              <h3>1. Find Your User Group</h3>
              <p>
                Check the <a href="#usergroups">participating user groups</a> section to find
                a community near you.
              </p>
            </div>
            <div className="join-step">
              <h3>2. Register Through Meetup</h3>
              <p>
                Each user group has their own registration page. Click on their Meetup link
                to RSVP for the event.
              </p>
            </div>
            <div className="join-step">
              <h3>3. Contact Your User Group Leader</h3>
              <p>
                If you have questions or would like to get involved, reach out to your nearest
                User Group Leader through the{' '}
                <a
                  href="https://builder.aws.com/community/user-groups"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  AWS Community User Groups directory
                </a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowToJoinSection;
